import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import FullScreenLoading from "../misc/FullScreenLoading";

class PrivateRoute extends Component {
  renderComponent() {
    const { component: Component } = this.props;

    return (props) => {
      if (this.props.auth_validating) {
        return <FullScreenLoading />;
      } else if (!!this.props.auth_token) {
        return <Component {...props} />;
      } else {
        return (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: this.props.location }
            }}
          />
        );
      }
    }
  }

  render() {
    const { component, ...rest } = this.props;
    return <Route {...rest} render={this.renderComponent()} />;
  }
}

const mapStateToProps = (state) => {
  return {
    auth_token: state.user.auth_token,
    auth_validating: state.user.auth_validating,
  };
};

export default connect(mapStateToProps)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/features/shared/components/misc/PrivateRoute.js